module.exports = __webpack_public_path__ + "static/media/sp15.16b295a8.JPG";